<template>
  <div v-bem v-if="articles.length">
    <h2 class="title">{{$t('blog.title')}}</h2>
    <slick :options="options" v-bem:carousel>
      <div v-for="article in articles" :key="article.slug" v-bem:carousel:item>
        <a
          v-bem:carousel:content
          :href="`https://www.succursalesrenault.ma/blog/${article.slug}`"
          :style="{backgroundImage: `url(https://www.succursalesrenault.ma/assets/blog/${article.image})`}"
        >
          <span>{{article.titre}}</span>
        </a>
      </div>
    </slick>
    <div class="text-center">
      <a href="https://www.succursalesrenault.ma/blog" class="button button--primary"><span class="button__text">{{$t('blog.see-more')}}</span></a>
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick'
import axios from 'axios'

export default {
  name: 'Blog',
  components: {
    Slick
  },
  data() {
    return {
      articles: [
      ],
      options: {
        arrows    : false,
        dots      : true,
        infinite  : true,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 520,
            settings: {
              slidesToShow: 1
            }
          },
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 2
            }
          },
        ]
      }
    }
  },
  created() {
    axios.get('https://www.succursalesrenault.ma/api/articles.php?type=onlinestore')
      .then(({status, data}) => {
        if (status === 200) this.articles = data
      })
      .catch(err => console.error(err))
  }
}
</script>

<style scoped lang="scss">
.blog {
  &__carousel {
    max-width: rem(1300);
		margin: rem(32) auto;
		&-item {
      display: table !important;
			margin: 0 auto;
			max-width: rem(380);
		}
		&-content {
			margin: 0 rem(8);
			position: relative;
			display: block;
			color: $white;
			text-decoration: none;
			height: rem(260);
			background-size: cover;
			background-position: center;
			&::before {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: linear-gradient(0deg, rgba(0,0,0,.7), transparent);
    		z-index: 1;
			}
			span {
				position: absolute;
				bottom: rem(16);
				left: rem(16);
				@include font-size(24);
				width: 100%;
				max-width: 80%;
				z-index: 2;
			}
		}
  }
}
</style>